export type RouteDocumentUploadPreset = {
  documentType: string;
  stage: 'loading' | 'unloading' | 'other';
  fileType: 'file' | 'photo';
};

export function normalizeRouteDocType(value: unknown): string {
  return String(value || '').toUpperCase();
}

export function routeDocMatchesRequirement(
  doc: Record<string, unknown>,
  reqKey: string
): boolean {
  const dt = normalizeRouteDocType(doc.documentType);
  switch (reqKey) {
    case 'CARRIER_CONTRACT_REQUEST':
      return dt === 'CARRIER_CONTRACT_REQUEST';
    case 'LOADING_PHOTO':
    case 'LOADING_PHOTOS':
      return dt === 'LOADING_PHOTO';
    case 'LOADING_DOCUMENTS':
      return dt === 'LOADING_TN' || dt === 'LOADING_DOCS' || dt === 'LOADING_DOCUMENTS';
    case 'UNLOADING_PHOTO':
    case 'UNLOADING_PHOTOS':
      return dt === 'UNLOADING_PHOTO';
    case 'UNLOADING_DOCUMENTS':
      return dt === 'UNLOADING_DOC' || dt === 'UNLOADING_DOCS' || dt === 'UNLOADING_DOCUMENTS';
    case 'CARRIER_INVOICE':
      return dt === 'CARRIER_INVOICE' || dt === 'LOADING_INVOICE';
    case 'CARRIER_UPD':
      return dt === 'UPD_ACT' || dt === 'UPD';
    case 'ORIGINAL_TN':
    case 'CARRIER_TN_TTH_ORIGINALS':
      return dt === 'ORIGINAL_TN' || dt === 'TN_ORIGINAL' || doc.isOriginalTN === true;
    case 'RAIL_WAYBILL':
      return dt === 'RAIL_WAYBILL';
    case 'AIR_WAYBILL':
      return dt === 'AWB';
    case 'CARGO_DOCS':
      return (
        dt === 'UNLOADING_DOC' ||
        (normalizeRouteDocType(doc.stage) === 'UNLOADING' && normalizeRouteDocType(doc.fileType) === 'FILE')
      );
    default:
      return false;
  }
}

export function uploadPresetForRouteRequirement(
  key: string
): RouteDocumentUploadPreset | null {
  switch (key) {
    case 'CARRIER_CONTRACT_REQUEST':
      return { documentType: 'CARRIER_CONTRACT_REQUEST', stage: 'other', fileType: 'file' };
    case 'LOADING_PHOTO':
    case 'LOADING_PHOTOS':
      return { documentType: 'LOADING_PHOTO', stage: 'loading', fileType: 'photo' };
    case 'LOADING_DOCUMENTS':
      return { documentType: 'LOADING_TN', stage: 'loading', fileType: 'file' };
    case 'UNLOADING_PHOTO':
    case 'UNLOADING_PHOTOS':
      return { documentType: 'UNLOADING_PHOTO', stage: 'unloading', fileType: 'photo' };
    case 'UNLOADING_DOCUMENTS':
      return { documentType: 'UNLOADING_DOC', stage: 'unloading', fileType: 'file' };
    case 'CARRIER_INVOICE':
      return { documentType: 'CARRIER_INVOICE', stage: 'other', fileType: 'file' };
    case 'CARRIER_UPD':
      return { documentType: 'UPD_ACT', stage: 'other', fileType: 'file' };
    case 'ORIGINAL_TN':
    case 'CARRIER_TN_TTH_ORIGINALS':
      return { documentType: 'ORIGINAL_TN', stage: 'other', fileType: 'file' };
    case 'RAIL_WAYBILL':
      return { documentType: 'RAIL_WAYBILL', stage: 'loading', fileType: 'file' };
    case 'AIR_WAYBILL':
      return { documentType: 'AWB', stage: 'loading', fileType: 'file' };
    case 'CARGO_DOCS':
      return { documentType: 'UNLOADING_DOC', stage: 'unloading', fileType: 'file' };
    default:
      return null;
  }
}
